import { render, staticRenderFns } from "./AddEvalColleaguesDialog.vue?vue&type=template&id=ce606baa"
import script from "./AddEvalColleaguesDialog.vue?vue&type=script&lang=js"
export * from "./AddEvalColleaguesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports